import { render, staticRenderFns } from "./list-field-filters.vue?vue&type=template&id=08f47738&"
import script from "./list-field-filters.vue?vue&type=script&lang=js&"
export * from "./list-field-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports